/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsList } from "../funcs/skillsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  Classifications,
  ListSkillsRequest,
  ListSkillsResponse,
  ListSkillsSecurity,
  Sort,
  SourceKinds,
} from "../models/operations/listskills.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SkillsQueryData = ListSkillsResponse;

export type SkillsInfiniteQueryData = PageIterator<
  ListSkillsResponse,
  { cursor: string }
>;

export type SkillsPageParams = PageIterator<
  ListSkillsResponse,
  { cursor: string }
>["~next"];

export function prefetchSkills(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillsRequest | undefined,
  security?: ListSkillsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSkillsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillsRequest | undefined,
  security?: ListSkillsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSkillsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SkillsPageParams,
    getNextPageParam: (previousPage: SkillsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSkillsQuery(
  client$: GramCore,
  request?: ListSkillsRequest | undefined,
  security?: ListSkillsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SkillsQueryData>;
} {
  return {
    queryKey: queryKeySkills({
      cursor: request?.cursor,
      limit: request?.limit,
      search: request?.search,
      sourceKinds: request?.sourceKinds,
      classifications: request?.classifications,
      tags: request?.tags,
      accessibleBy: request?.accessibleBy,
      sort: request?.sort,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillsQueryFn(ctx): Promise<SkillsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSkillsInfiniteQuery(
  client$: GramCore,
  request?: ListSkillsRequest | undefined,
  security?: ListSkillsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SkillsPageParams>,
  ) => Promise<SkillsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySkillsInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      search: request?.search,
      sourceKinds: request?.sourceKinds,
      classifications: request?.classifications,
      tags: request?.tags,
      accessibleBy: request?.accessibleBy,
      sort: request?.sort,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillsQuery(ctx): Promise<SkillsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(skillsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(skillsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySkills(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    search?: string | undefined;
    sourceKinds?: Array<SourceKinds> | undefined;
    classifications?: Array<Classifications> | undefined;
    tags?: Array<string> | undefined;
    accessibleBy?: Array<string> | undefined;
    sort?: Sort | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "list", parameters];
}

export function queryKeySkillsInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    search?: string | undefined;
    sourceKinds?: Array<SourceKinds> | undefined;
    classifications?: Array<Classifications> | undefined;
    tags?: Array<string> | undefined;
    accessibleBy?: Array<string> | undefined;
    sort?: Sort | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "list", "infinite", parameters];
}
